module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_9016.e8108d4f.png";